import { render } from "./KeepAwakePropsCmp.vue?vue&type=template&id=c0bf4ca0"
import script from "./KeepAwakePropsCmp.vue?vue&type=script&lang=js"
export * from "./KeepAwakePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__